const miscellaneous = {
    scrollTop: 'Scroll To Top',
    scrollDown: 'scroll down',
    siteBy: 'Website by',
}

export default miscellaneous
